import React from 'react'
// import phhoneValidate from 'phone'
// import emailValidate from 'email-validator'
import { isEmpty, isUndefined } from 'lodash'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers, withState, withProps, branch, renderComponent } from 'recompose'
import { injectIntl, FormattedMessage } from 'react-intl'

import Select from '../Select'

import { fetchingState } from './../../helpers/hocs.js'
import { getSettingsInfo, getIsLogged, getUserID } from '../../selectors/user.js'
import { getUserSettings, setUserSettings, getUser } from '../../store/reducers/auth.js'

import Form from './../Form'
import Login from './Login'
import Checkbox from '../Checkbox'
import CommunicationChannels from '../CommunicationChannels'
import { sendMindbox } from './../../helpers/hocs.js'


const EditForm = ({ isLogged, data, info, errors, setCommunicationChannels, setDataHandler, submit, fetching, intl, setMode, peoceed, months }) => {
  return(!isLogged || !info || !data) ? null : (
  <div className='modal_edit'>
    <div className='modal__field modal__field_profile'>
      <Form value={data.name} placeholder={intl.formatMessage({id: 'profile_edit.name'})} onInput={setDataHandler('name')} 
      classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
      {errors.name && <div className='Text'>{errors.name}</div>}
      <Form value={data.surname} placeholder={intl.formatMessage({id: 'profile_edit.surname'})} onInput={setDataHandler('surname')} 
      classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
      {errors.surname && <div className='Text' classname="Form__field Form__field-settings">{errors.surname}</div>}
      <Form value={data.phone} classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus disabled />
      <Form value={data.email} classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus disabled/>
      
      <div className="Form__field EmailPopup__bigText Form__field-settings"><FormattedMessage id='profile_edit.birthday'/></div>
      <div className="Form__field Form__field-settings-birthdayForm">
        <div className="Form__field Form__field-settings Form__field-settings-birthday">
          <Form value={data.birthday} placeholder={intl.formatMessage({id: 'profile_edit.day'})} onInput={setDataHandler('birthday')} 
          classname="Form__field Form__field-settings" type="Number" disableBtn noEnter noAutoFocus min='1' />
        </div>
        <div className="Form__field Form__field-settings Form__field-settings-month">
          <Select classname="Form__field Form__field-settings" placeholder={intl.formatMessage({id: 'profile_edit.month'})} value={data.birthmonth}
                        items={months} onSubmit={peoceed.bind(this, 'birthmonth')} />
        </div>
      </div>
      {errors.birthday && <div className="Form__field Form__field-settings Text">{errors.birthday}</div>}

      <Form value={data.telegram} placeholder={intl.formatMessage({id: 'profile_edit.telegramId'})} onInput={setDataHandler('telegram')} 
      classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
      <Form value={data.telegramName} placeholder={intl.formatMessage({id: 'profile_edit.telegramName'})} onInput={setDataHandler('telegramName')} 
      classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
      {/*/<Form value={data.facebook} placeholder={intl.formatMessage({id: 'profile_edit.facebook'})} onInput={setDataHandler('facebook')} 
      classname="Form__field Form__field-settings" disableBtn noEnter noAutoFocus />
      */}
      <div className="Form__field EmailPopup__bigText Form__field-settings"><FormattedMessage id='profile_edit.preferred_methods'/></div>
      <CommunicationChannels userSettings={data} setUserSettings={setCommunicationChannels}></CommunicationChannels>

      <br /><br /><br />
      <button type='submit' style={{ marginBottom: 12 }} className='Button Button_white' onClick={submit}><FormattedMessage id='profile_edit.save' /></button>
      &nbsp;&nbsp;&nbsp;
      <button type='submit' className='Button Button_white' onClick={setMode('login')}><FormattedMessage id='profile_edit.login' /></button>
      &nbsp;&nbsp;&nbsp;
      <button type='submit' className='Button Button_white' onClick={setMode('email')}><FormattedMessage id='profile_edit.email' /></button>
    </div>
  </div>
)}

const mapStateToProps = state => ({
  info: getSettingsInfo(state),
  isLogged: getIsLogged(state),
  userId: getUserID(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({ getUserSettings, setUserSettings, getUser }, dispatch)

export default injectIntl(compose(
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps),
  withState('mode', 'setMode', 'edit','editEmail'),

  withHandlers({
    setMode: ({ setMode }) => mode => e => {
      e && e.preventDefault()
      setMode(mode)
    },
  }),
  branch(
    props => props.mode === 'login',
    renderComponent(props => <Login onSuccess={props.setMode('edit')} />)
  ),
  branch(
    props => props.mode === 'email',
    renderComponent(props => <Login onSuccess={props.setMode('editEmail')} mode='editEmail'/>)
  ),
  withState('data', 'setData', {}),
  withState('errors', 'setErrors', {}),
  withState('months', 'setMonths', {}),
  
  withProps(props => {
    let data = { ...props.info, ...props.data }
    return ({ data })
  }),
  withHandlers({
    setDataHandler: ({ setData, data }) => field => value => {
      if (field == 'birthday' && ((value > 31) || (value === "0") || (value < 0) || (value === "-")))
        return
      if (field == 'birthday' && (value > 0))
        value = Number(value)
      data[field] = value
      setData(data)
    },
    setCommunicationChannels: ({data, setData}) => field => value => {//получение данных с компонента Предпочтительные каналы связи
      setData(data)
    },
    submit: ({ setUserSettings, getUser, setErrors, data, info, fetchingWrap, intl, months, userId }) => async e => {
      e && e.preventDefault()
      let errors = {}

      if (!isUndefined(data.name) && !data.name) errors.name = intl.formatMessage({id: 'profile_edit.field_required'})
      if (!isUndefined(data.surname) && !data.surname) errors.surname = intl.formatMessage({id: 'profile_edit.field_required'})
      // if (!data[field]) errors[field] = intl.formatMessage({id: 'profile_edit.field_required'})
      // if (field === 'phone' && !phhoneValidate(data[field], 'RUS').length) errors[field] = intl.formatMessage({id: 'profile_edit.phone_format'})
      // if (field === 'email' && !emailValidate.validate(data[field])) errors[field] = intl.formatMessage({id: 'profile_edit.email_format'})
      if ((!data.birthday && (data.birthmonth != null)) || (data.birthday && (data.birthmonth == null))) {//если не введен день или месяц - день рождения не записываем
        data.birthday = null
        data.birthmonth = null
      } else if (data.birthday && data.birthmonth) {
        if ((data.birthday < 1)
          || (([3, 5, 8, 10].indexOf(data.birthmonth) > -1) && (data.birthday > 30))
          || ((data.birthmonth == 1) && (data.birthday > 29)))
          errors.birthday = intl.formatMessage({id: 'profile_edit.invalid_date'})
      }

      setErrors(errors)
      if (!isEmpty(errors)) return
      let result = await fetchingWrap(setUserSettings.bind(this, { name: info.name, surname: info.surname, birthday: info.birthday,...data }))
      if (result === 200) {
        console.log('данные сохраненны - можно вызывать mindbox')
        const choseChannels = []
        if (data.notifyEmail) choseChannels.push('Email')
        if (data.notifyFacebook) choseChannels.push('Facebook')
        if (data.notifyPhone) choseChannels.push('Телефон')
        if (data.notifySMS) choseChannels.push('SMS')
        if (data.notifyTelegram) choseChannels.push('Telegram')
        if (data.notifyWhatsapp) choseChannels.push('WhatsApp')

        const mindboxData = {
          "customer": {
            "ids": {
              "websiteID": userId
            },
            "birthDate": `${data.birthday} ${months[data.birthmonth]}`,
            "lastName": data.surname,
            "firstName": data.name,
            "email": data.email,
            "mobilePhone": data.phone,
            "customFields": {
              "communicationchannel": [...choseChannels],
              "telegramID": data.telegram || '',
              "telegramName": data.telegramName || '',
              "facebook": data.facebook || ''
            },
          },
          "executionDateTimeUtc": new Date()
        }

        sendMindbox(mindboxData, 'edit')
      }
      await getUser()
    },
    peoceed: ({ setData, data }) => (field, e) => {
      e && e.preventDefault && e.preventDefault()
      data[field] = (e == null) ? e : Number(e)
      setData(data)
    }
  }),
  lifecycle({
    componentWillMount () {
      this.props.getUserSettings()
      let months = {null: '\n'}//массив месяцев
      for (let i = 0; i < 12; i++) {
        months[i] = this.props.intl.formatMessage({id: 'profile_edit.birthday.' + i})
      }
      this.props.setMonths(months)
    },
    componentWillReceiveProps(np) {
      console.log('какие данные в форме редактирования********************', np)
    }
  })
)(EditForm))



// WEBPACK FOOTER //
// ./src/components/Profile/Edit.jsx